import ROUTES from '../../enums/routes';

// eslint-disable-next-line no-unused-vars
export default function getClientQaNavigation(store) {
  return [
    {
      icon: 'dashboard',
      title: 'Dashboard',
      route: ROUTES.DASHBOARD,
    },
    {
      icon: 'content_paste',
      title: 'Incidents',
      route: ROUTES.INCIDENTS_REGULAR,
    },
    {
      icon: 'notification_important',
      title: 'Monitor/Alerts',
      route: ROUTES.INCIDENTS_MONITORS,
    },
    {
      icon: 'mdi-head-lightbulb-outline',
      title: 'QA/QI Insights',
      route: ROUTES.INSIGHTS,
    },
  ];
}
